export class DetectDeviceService {
  public static isIOSPlatform(): boolean {
    return (
      [
        'iPad Simulator',
        'iPhone Simulator',
        'iPod Simulator',
        'iPad',
        'iPhone',
        'iPod',
        'MacIntel',
        'MacPPC',
        'Mac68K',
        'Mac',
      ].includes(navigator.platform) ||
      // iPad on iOS 13 detection
      (navigator.userAgent.includes('Mac') && 'ontouchend' in document)
    );
  }

  public static isTouchDevice(): boolean {
    return 'ontouchstart' in window || 'ontouchend' in document;
  }
}
